const BUBBLE_SPEED_MULTIPLIER = 2.8;

const getBubbleDuration = (seconds) =>
  `${seconds * BUBBLE_SPEED_MULTIPLIER}s`;

const BACKGROUND_BUBBLES = [
  ["8%", "48px", "-10s", 15.8, "24px", "0.72"],
  ["22%", "28px", "-22s", 16.6, "-18px", "0.58"],
  ["72%", "58px", "-15s", 17.2, "-30px", "0.66"],
  ["88%", "24px", "-29s", 15.4, "18px", "0.64"],
  ["48%", "38px", "-6s", 16.2, "26px", "0.5"],
  ["61%", "18px", "-35s", 14.8, "-12px", "0.68"],
];

const FIELD_LIGHT_BUBBLES = [
  ["-18px", "100%", "22px", "#ffffff", "-8s", 11.8, "10px"],
  ["calc(100% - 10px)", "100%", "18px", "#fff6a8", "-17s", 12.4, "-14px"],
  ["18px", "100%", "14px", "#dff2c4", "-25s", 11.6, "16px"],
  ["calc(100% - 30px)", "100%", "12px", "#ffffff", "-13s", 12, "-10px"],
  ["46%", "100%", "10px", "#fff9d2", "-4s", 11.2, "8px"],
];

function BackgroundLights({ showFieldAura = true, wide = false }) {
  return (
    <>
      <div
        className={`pointer-events-none absolute z-0 ${
          wide
            ? "refine-wide-lights inset-x-[-18%] top-[-58vh] bottom-[-18px]"
            : "inset-x-[-18%] top-[-58vh] bottom-[-18px]"
        }`}
      >
        <div className="absolute inset-x-[-8%] bottom-[-70px] h-48 rounded-[50%] bg-[radial-gradient(circle,rgba(244,217,78,0.62)_0%,rgba(106,174,37,0.25)_34%,rgba(255,255,255,0.1)_54%,transparent_72%)] blur-2xl" />
        {BACKGROUND_BUBBLES.map(
          ([left, size, delay, duration, drift, opacity]) => (
            <span
              key={`${left}-${size}`}
              className="refine-light-bubble absolute bottom-0 rounded-full border border-[#f4d94e]/45 bg-[#fff6a8]/30 shadow-[0_0_38px_rgba(244,217,78,0.7),0_0_24px_rgba(255,255,255,0.42),inset_0_0_18px_rgba(255,255,255,0.58)] backdrop-blur-[1px]"
              style={{
                left,
                width: size,
                height: size,
                "--bubble-delay": delay,
                "--bubble-duration": getBubbleDuration(duration),
                "--bubble-drift": drift,
                "--bubble-opacity": opacity,
              }}
            />
          )
        )}
      </div>

      {showFieldAura ? (
        <div className="refine-input-aura pointer-events-none absolute inset-x-[-14px] bottom-[-14px] top-[-14px] rounded-[1.75rem] bg-[radial-gradient(circle_at_50%_92%,rgba(255,248,218,0.44),rgba(219,181,51,0.24)_38%,rgba(219,181,51,0.08)_68%,transparent_100%)] blur-xl" />
      ) : null}
      {FIELD_LIGHT_BUBBLES.map(([left, top, size, color, delay, duration, floatX]) => (
        <span
          key={`${left}-${top}`}
          className="refine-visible-bubble pointer-events-none absolute z-20 rounded-full border border-[#f4d94e]/45 shadow-[0_0_22px_rgba(244,217,78,0.65),0_0_14px_rgba(255,255,255,0.34),inset_0_0_10px_rgba(255,255,255,0.52)]"
          style={{
            left,
            top,
            width: size,
            height: size,
            backgroundColor: color,
            "--visible-bubble-delay": delay,
            "--visible-bubble-duration": getBubbleDuration(duration),
            "--visible-bubble-x": floatX,
          }}
        />
      ))}

      <style>{`
        @keyframes refine-bubble-rise {
          0% { transform: translate3d(0, 72px, 0) scale(0.72); opacity: 0; }
          18% { opacity: var(--bubble-opacity); }
          82% { opacity: calc(var(--bubble-opacity) * 0.88); }
          100% { transform: translate3d(var(--bubble-drift), -720px, 0) scale(1.18); opacity: 0; }
        }

        @keyframes refine-input-glow {
          0%, 100% { opacity: 0.55; transform: scale(0.98); }
          50% { opacity: 0.95; transform: scale(1.02); }
        }

        @keyframes refine-visible-bubble-float {
          0% { transform: translate3d(0, 80px, 0) scale(0.74); opacity: 0; }
          16% { opacity: 0.9; }
          82% { opacity: 0.82; }
          100% { transform: translate3d(var(--visible-bubble-x), -520px, 0) scale(1.16); opacity: 0; }
        }

        .refine-light-bubble {
          animation: refine-bubble-rise var(--bubble-duration) ease-in-out infinite;
          animation-delay: var(--bubble-delay);
        }

        .refine-input-aura {
          animation: refine-input-glow 5.5s ease-in-out infinite;
        }

        .refine-visible-bubble {
          animation: refine-visible-bubble-float var(--visible-bubble-duration) ease-in-out infinite;
          animation-delay: var(--visible-bubble-delay);
        }

        @media (prefers-reduced-motion: reduce) {
          .refine-light-bubble,
          .refine-input-aura,
          .refine-visible-bubble {
            animation: none !important;
          }
        }

        @media (min-width: 640px) {
          .refine-wide-lights {
            inset-inline: -30vw;
            top: -20rem;
            bottom: -2rem;
          }
        }
      `}</style>
    </>
  );
}

export default BackgroundLights;
